var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.name))]),_c('ul',_vm._l((_vm.pupils),function(pupil){return _c('li',{key:pupil.$id},[_vm._v(" "+_vm._s(pupil.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }